import {Injectable} from '@angular/core';
import {ApiService} from '@abstract/api.service';
import {RegulatoryTuple} from './regulatory-fields-value.interface';

/**
 * Сервис вложенной формы создания оборудования
 */
@Injectable()
export class ApparatusFormFieldService extends ApiService {

    protected baseUrl = 'apparatus/groups';

    resetTuplesLastValue() {
    }

    getGroupsByMethods(value: RegulatoryTuple[] = []) {
        const tuples = [];

        /* fieldMethodObjectTuples ожидает строку с перечислением методов и объектов
         * в формате methodId-objectId напримре (3-2,3-6,5-18).
         * Поэтому тут мы мапим значение методов контроля формы в коллекцию, которую потом преобразуем в строку
         * */
        value.forEach(item => {
            item.object_ids.forEach(id => {
                tuples.push(item.method_id + '-' + id);
            });
        });

        return this.get({
            queryParams: {
                fieldMethodObjectTuples: tuples.join(',')
            }
        });
    }

}
